
import { defineComponent, PropType } from 'vue';
import {
  IBienBanResponseBase,
  IHopDongResponseBase,
} from '@/core/interfaces/ApiResponses';
import { useDateTime } from '@/core/hooks/use-date-time-hook';
import DivRow from '@/layout/_shared/DivRow.vue';
import DivCol from '@/layout/_shared/DivCol.vue';
import Setting from '@/components/shared/setting/Setting.vue';
import type { SettingAction } from '@/components/shared/setting/Setting.vue';
import { openBienBanKiemNghiemPdf } from '@/components/shared/pdf-viewer/open-bien-ban-kiem-nghiem-pdf';
import IconPrint from '@/icons/IconPrint.vue';

export default defineComponent({
  name: 'bien-ban-kiem-nghiem-table',

  components: {
    DivRow,
    DivCol,
    Setting,
  },

  emits: ['on-detail-button-click'],

  setup() {
    const { moment } = useDateTime();

    return {
      moment,
    };
  },

  props: {
    hopDongData: {
      type: Object as PropType<IHopDongResponseBase>,
      required: true,
    },
    items: {
      type: Array as PropType<Array<IBienBanResponseBase>>,
      default: () => [],
    },
  },

  methods: {
    getSettingActions(row: IBienBanResponseBase): SettingAction[] {
      return [
        {
          icon: IconPrint,
          label: 'In BBKN',
          tooltip: 'In BBKN',
          onClick: () => this.openPdfViewerInNewTab(row),
        },
      ];
    },

    onDetailButtonCLicked(bienBanData: IBienBanResponseBase) {
      this.$emit('on-detail-button-click', {
        bienBan: bienBanData,
      });
    },

    openPdfViewerInNewTab(row: IBienBanResponseBase) {
      openBienBanKiemNghiemPdf(this.$router, row.id);
    },
  },
});
